import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IATMTransactionInquiryDetailsFormMeta {
  corporateBankName: FormInputMeta,
  terminalNumber: FormInputMeta,
  typeCard: FormInputMeta,
  status: FormInputMeta,
  cardNumber: FormInputMeta,
  oneDate: FormInputMeta,
  transactionStatus: FormInputMeta,
  serialNumber: FormInputMeta,
  amount: FormInputMeta,
  currency: FormInputMeta,
  authorizationNumber: FormInputMeta,
  acquirerInstitutionIdentificationCode: FormInputMeta,
  stand: FormInputMeta,
  track2: FormInputMeta,
  responseCode: FormInputMeta,
  retrievalReferenceNumber: FormInputMeta,
  cardAcceptorId: FormInputMeta,
  cardAcceptorTerminalIdCode: FormInputMeta,
  accountFrom: FormInputMeta,
  accountTo: FormInputMeta,

  schema: any;
}

const ATMTransactionInquiryDetailsFormMeta = {} as IATMTransactionInquiryDetailsFormMeta;

// ATMTransactionInquiryDetails
ATMTransactionInquiryDetailsFormMeta.corporateBankName = {
  name: "corporateBankName",
  type: "text",
  label: "Nom de la banque",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
  };
  ATMTransactionInquiryDetailsFormMeta.terminalNumber = {
  name: "terminalNumber",
  type: "text",
  label: "Numéro de terminal",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
  };
  ATMTransactionInquiryDetailsFormMeta.typeCard = {
  name: "typeCard",
  type: "text",
  label: "Type de carte",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
  };
  ATMTransactionInquiryDetailsFormMeta.status = {
  name: "status",
  type: "text",
  label: "Statut",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
  };
  ATMTransactionInquiryDetailsFormMeta.cardNumber = {
  name: 'cardNumber',
  type: 'text',
  label: 'Numéro de la carte',
  placeholder: '',
  validation: yup.string().required(),
  };
  ATMTransactionInquiryDetailsFormMeta.oneDate = {
  name: "oneDate",
  type: "date",
  label: "Date",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
  };
  ATMTransactionInquiryDetailsFormMeta.transactionStatus = {
  name: "transactionStatus",
  type: "text",
  label: "Statut de la transaction",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
  };
  ATMTransactionInquiryDetailsFormMeta.serialNumber = {
  name: "serialNumber",
  type: "text",
  label: "Numéro de série",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
  };
  ATMTransactionInquiryDetailsFormMeta.amount = {
  name: "amount",
  type: "text",
  label: "Montant",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
  };
  ATMTransactionInquiryDetailsFormMeta.currency = {
  name: "currency",
  type: "text",
  label: "Devise",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
  };
  ATMTransactionInquiryDetailsFormMeta.authorizationNumber = {
  name: "authorizationNumber",
  type: "text",
  label: "Numéro d\'autorisation",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
  };
  ATMTransactionInquiryDetailsFormMeta.acquirerInstitutionIdentificationCode = {
  name: "acquirerInstitutionIdentificationCode",
  type: "text",
  label: "Code d\'identification de l\'institution de l\'acquéreur",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
  };
  ATMTransactionInquiryDetailsFormMeta.stand = {
  name: "stand",
  type: "text",
  label: "Stand",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
  };
  ATMTransactionInquiryDetailsFormMeta.track2 = {
  name: "track2",
  type: "text",
  label: "Piste 2",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
  };
  ATMTransactionInquiryDetailsFormMeta.responseCode = {
  name: "responseCode",
  type: "text",
  label: "Code de réponse",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
  };
  
  ATMTransactionInquiryDetailsFormMeta.retrievalReferenceNumber = {
  name: "retrievalReferenceNumber",
  type: "text",
  label: "Numéro de référence de l\'extraction",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
  };
  ATMTransactionInquiryDetailsFormMeta.cardAcceptorId = {
  name: "cardAcceptorId",
  type: "text",
  label: "ID de l\'accepteur de la carte",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
  };
  
  ATMTransactionInquiryDetailsFormMeta.cardAcceptorTerminalIdCode = {
  name: "cardAcceptorTerminalIdCode",
  type: "text",
  label: "Code d\'identification du terminal de l\'accepteur de la carte",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
  };
  ATMTransactionInquiryDetailsFormMeta.accountFrom = {
  name: "accountFrom",
  type: "text",
  label: "Du compte",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
  };
  ATMTransactionInquiryDetailsFormMeta.accountTo = {
  name: "accountTo",
  type: "text",
  label: "Au compte",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
  };
  


ATMTransactionInquiryDetailsFormMeta.schema = yup.object().shape(getValidationSchema(ATMTransactionInquiryDetailsFormMeta));

export default ATMTransactionInquiryDetailsFormMeta;